import React, { useEffect, useRef, useState } from 'react';
import { useTable, usePagination, useSortBy, useFilters, useGlobalFilter, useAsyncDebounce } from "react-table";
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import { BsPrinter } from 'react-icons/bs';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { CgPushChevronLeft, CgPushChevronRight } from "react-icons/cg";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FaCircleArrowLeft } from 'react-icons/fa6';
import { Col, Row } from 'react-bootstrap';

export function CommonReactTable(props) {
    const { columns, data, filename, showFooter, serachAlign, pagination, search, paginationCount, headerName, headColumCount, isBack, isBackFunction, printFalg } = props;
    const calculatedPageSize = paginationCount === "All" ? data?.length : 10;
    const {
        getTableBodyProps,
        headerGroups,
        footerGroups,
        page,
        canPreviousPage,
        canNextPage,
        preGlobalFilteredRows,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize },
        setPageSize,
        globalFilter,
        setGlobalFilter,
        rows,
        prepareRow
    } = useTable({
        columns,
        data,

        initialState: { pageIndex: 0, pageSize: calculatedPageSize },

    },

        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    );
    useEffect(() => {
        if (paginationCount === "All") {
            setPageSize(data?.length); // Set to total rows if "All" is selected
        } else {
            setPageSize(10); // Default to 10 rows per page
        }
    }, [paginationCount, data?.length, setPageSize]);

    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(valuess => {
        setGlobalFilter(valuess)
    }, 200)
    // let componentRef = useRef();
    // const handleprint = useReactToPrint({
    //     content: () => componentRef.current,
    //     documentTitle: "college-data",
    // });

    const [currentPage, setCurrentPage] = useState(1);
    function rowsCount(a) {
        let countSum = 0
        const rdata = data?.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

        if (a?.FooterParamAction) {
            let params1 = a?.Footerparams?.split('-')[0]
            let params2 = a?.Footerparams?.split('-')[1]
            let paramsum1 = rdata?.reduce((sum, row) => sum + row[params1], 0)
            let paramsum2 = rdata?.reduce((sum, row) => sum + row[params2], 0)
            if (a.FooterParamAction === '-') {
                countSum = parseInt(paramsum1) - parseInt(paramsum2)
            }
            else {
                countSum = parseInt(paramsum1) + parseInt(paramsum2)
            }

        }
        else {
            countSum = rdata?.reduce((sum, row) => sum + row[a.Footer], 0)
        }

        if (isNaN(countSum) === false) {
            return countSum
        }
        else {
            return 0
        }
    }
    const printRef = useRef();
    const handlePrint = () => {
        const content = printRef.current; // Get the specific div content
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
              <head>
                <title>Print Content</title>
                <style>
                .form-sub {margin-right:20px;}
                  body {
                    font-family: Arial, sans-serif;
                    border:1px solid black;
                    padding: 20px 10px 20px 10px;
                  }
                 h5{
                 padding-top:-20px;
                 margin-top:-20px;
                 }
                  .table{
                      width: 100%;
          margin-bottom: 1rem;
          color: #212529;
          vertical-align: top;
          border-color: #dee2e6;
                  }
     
                 
      .table-bordered {
        border: 1px solid #dee2e6;
      }
     
      .table-bordered th,
      .table-bordered td {
        border: 1px solid #dee2e6;
         margin-left: 0.5rem !important;
      }
     
      .table-bordered thead th,
      .table-bordered thead td {
        border-bottom-width: 1px;
      }
     
      .table-borderless th,
      .table-borderless td,
      .table-borderless thead th,
      .table-borderless tbody + tbody {
        border: 0;
      }
     
     
      .table-striped tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, 0.05);
      }
      .table-dark.table-striped tbody tr:nth-of-type(odd) {
        background-color: rgba(255, 255, 255, 0.05);
      }
     
      .personal-head {
          margin: 5px 0px -10px 0px;
      }
          .mt-31 {
          margin-top: 1rem !important;
      }
       
      .personal-row {
          border: 1px solid #dddddd;
          padding: 15px 15px 0px 15px;
          margin-bottom :5px;
      }
          .personal-head span {
          font-size: 16px;
          color:rgb(154, 154, 154);
          font-weight: 600;
          background: rgb(44 119 125);
          padding: 5px 10px;
          margin-left: 30px;
          width: 200px;
          height: 20px;
          display: inline-block;
          font-family: "Poppins", sans-serif !important;
      }
          .table tbody tr td, .table tbody tr th {padding:5px 5px;}
          .table tbody tr td, .alert {font-size:14px;}
          .table-pass thead tr td {font-size:14px; text-align:center;padding:5px 5px;}
          .table tbody tr td b, .table tbody tr th {font-size:15px;}
               </style>
               
              </head>
              <body>${content.outerHTML}</body>
            </html>
          `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    return (
        <React.Fragment>
            <Row className='mt-1 mb-2'>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}
                    className="page-titlespacing d-flex justify-content-between">
                    {search === "false" ? "" :
                        <div className={serachAlign === 'right' ? 'text-end' : "none"}>
                            <span className='me-3'><input value={value || ""} name={`search_${Date.now()}`} onChange={e => { setValue(e.target.value); onChange(e.target.value); }}
                                placeholder="Search" style={{ fontSize: '1.1rem', border: '1' }} />
                            </span>
                            <ReactHtmlTableToExcel id="test-table-xls-button"
                                className="pull-right btn btn-sm btn-success" table="table-to-xls"
                                filename={filename} sheet="tablexls"
                                buttonText={<PiMicrosoftExcelLogoFill size={20} title="Excel" />} />&nbsp;
                            {printFalg !== 'false' && (
                                <BsPrinter onClick={() => { handlePrint() }} title="Print" className=" btn btn-primary btn-sm"
                                    style={{ fontSize: '32px' }} />
                            )}
                            &emsp;
                            {isBack == true &&
                                <button type='button' className="btn btn-secondary btn-sm"
                                    onClick={() => { isBackFunction() }}>
                                    <FaCircleArrowLeft size={20} /> Back</button>}
                        </div>}
                </Col>
            </Row>
            <div className="custom-table-scroll-wrapper table-container table-scroll " id='myDiv' ref={printRef} style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
            }}>

                <table className="table table-bordered table-striped  mt-0" style={{
                    minWidth: '900px',
                    whiteSpace: 'nowrap',
                }}
                    id="table-to-xls">
                    <thead style={{ background: 'azure' }}>
                        {headerName && (
                            <tr className='text-center' style={{ backgroundColor: 'beige', color: 'brown' }}>
                                <th colSpan={headColumCount}>{headerName}</th>
                            </tr>)}
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers?.map((column, aindex) => (
                                    <th key={aindex} {...column?.getHeaderProps(column?.getSortByToggleProps())}
                                        data-toggle="tooltip" animation="true" title={column?.tooltipmsg}
                                        className={column?.customClassName}
                                        style={{ textAlign: column?.style === 'center' ? 'center' : "none" }}>
                                        {column?.render('Header')}
                                        <span>
                                            {column?.isSorted
                                                ? column?.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} style={{ fontSize: "12px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()} key={index}>
                                    {row.cells.map((cell, bindex) => {
                                        return <td key={bindex} {...cell.getCellProps()}
                                            className={cell?.column?.customClassName}
                                            style={{ overflowWrap: "break-word", whiteSpace: 'normal' }}>
                                            {cell.render("Cell")}</td>;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                    {showFooter === "true" ? <tfoot style={{ background: 'azure' }}>
                        <tr>
                            {footerGroups[0].headers.map((column, cindex) => (
                                <td key={cindex} {...column.getFooterProps()}
                                    className={column?.customClassName}
                                    style={{
                                        border: '1px solid lightblue',
                                        cursor: column.isClickable ? 'pointer' : 'auto',
                                        textDecoration: column.isClickable ? 'underline' : null,
                                        color: column.isClickable ? "Highlight" : "none",
                                    }} onClick={() => {
                                        if (column.isClickable) {
                                            column.FooterFunc(); // Call the function on click
                                        }
                                    }}>
                                    {column.Footer === 'Total' ? column.Footer : typeof (column.Footer) === 'string' ? rowsCount(column) : ''}
                                </td>
                            ))}
                        </tr>
                    </tfoot> : null}

                </table>
            </div>
            {pagination === "true" &&
                <div className="pagination mt-2">
                    <button type='button' onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><CgPushChevronRight size={21} /></button>&emsp;
                    <button type='button' onClick={() => nextPage()} disabled={!canNextPage}><FaChevronRight /></button>&emsp;
                    <button type='button' onClick={() => previousPage()} disabled={!canPreviousPage}><FaChevronLeft /></button>&emsp;
                    <button type='button' onClick={() => gotoPage(0)} disabled={!canPreviousPage}><CgPushChevronLeft size={21} /></button>&emsp;
                    <button type='button' className='mt-1'>&emsp;{currentPage} - <strong>{pageSize}</strong> of <strong>{preGlobalFilteredRows?.length} </strong>  &emsp;</button>
                    <select value={pageSize} onChange={e => {
                        setPageSize(Number(e.target.value)); setCurrentPage(1);
                    }}>
                        <option value={rows.length}>All</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                    </select>
                    Rows per page : &emsp;
                </div>}
        </React.Fragment>
    );
}
